import { Paper } from "@mantine/core"
import { useTranslation } from "react-i18next"
import { TopProduct } from "../hooks"
import { CardHeader } from "./CardHeader"
import classes from "../real.module.css"
import { RankList } from "./RankList"

interface Props {
  products: TopProduct[]
}

export function TopProductsCard({ products }: Props) {
  const { t } = useTranslation(["dashboard", "common"])

  return (
    <Paper className={classes.card}>
      <CardHeader
        title={t("dashboard:widgets.topProducts")}
        helpKey="order.dashboard.section.top-products"
        subtitle={`${t("dashboard:widgets.topProductsSub", { defaultValue: "Хамгийн их захиалагдсан" })} · ${t("dashboard:selectedMonth")}`}
      />

      <RankList
        items={products.map((item, index) => ({
          key: `${index}-${item.name}`,
          name: item.name,
          count: item.count,
          value: `${item.count} ${t("dashboard:numberFormat.unit")}`,
        }))}
      />
    </Paper>
  )
}
